import { queryClient } from '../queryClient';

import { createMostWatchedQueryOptions } from './queryOptions';

export function fetchMostWatchedQuery(userId: string) {
  return queryClient.fetchQuery(createMostWatchedQueryOptions({ userId }));
}
